// extracted by mini-css-extract-plugin
export default {"bg":"styles_bg__DaZql","footer":"styles_footer__UrKlc"};